const setListOfImpressionStatus = (list) => {
    return {
        type: 'SET_LIST_OF_IMP_STATUS',
        payload: list
    };
};

//eslint-disable-next-line
export default {
    setListOfImpressionStatus
};
